  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" >
    <v-row no-gutters>
      <v-col >

      <div class="container">
    <line-chart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"/>
  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>

import LineChart from '../../../components/Chart.vue'
export default {
  name: 'LineChartContainer',
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: {
      labels: ['January', 'February', 'Marco', 'Abril', 'Maio', 'Junho', 'Agosto', 'Setembro', 'Outbro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          label: ['red', 'blue' ],

          // Color: ['red', 'blue' ],
          borderColor: [
            'rgba(255, 99, 132, 1)'

          ],
          backgroundColor: 'rgba(76, 175, 80, 0.0)',
          data: [40, 20, 10, 2, 40, 20, 440, 20, 40, 230, 40, 420]
        }, {
          label: 'Data two',
          borderColor: [

            'rgba(54, 162, 235, 1)'

          ],
          backgroundColor: 'rgba(76, 175, 80, 0.0)',
          data: [140, 20, 110, 2, 40, 250, 440, 201, 40, 30, 40, 20]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
    //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
